/* Package JSON Import will be here */
import React from 'react';
import { Table, Button, Segment, Header, Icon } from 'semantic-ui-react';
import './curd.css';
import Create from './create/create.container'
import Update from './update/update.container';

const ReadComponent = props => {
    return (
        <Segment.Group>
            <Segment className="stickyHeader">
                <Header as="h3" size='medium' textAlign='center'> React CRUD Operations
                <Button className="float-right" primary size='small' onClick={() => props.onCreate()}>
                        <Icon style={{marginRight:'0'}} name="plus" />
                    </Button>
                </Header>
            </Segment>
            <Segment className="overflowScroll pb-5 ">
                <Table unstackable singleLine>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className="padding">First Name</Table.HeaderCell>
                            <Table.HeaderCell className="padding">Last Name</Table.HeaderCell>
                            <Table.HeaderCell className="padding">Checkbox Value</Table.HeaderCell>
                            <Table.HeaderCell className="padding">Update</Table.HeaderCell>
                            <Table.HeaderCell className="padding">Delete</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {props.users && props.users.map((data) => {
                            return (
                                <Table.Row key={data.id}>
                                    <Table.Cell className="text-left">{data.firstName}</Table.Cell>
                                    <Table.Cell className="text-left">{data.lastName}</Table.Cell>
                                    <Table.Cell className="text-left">{data.checkbox ? 'Checked' : 'Unchecked'}</Table.Cell>

                                    <Table.Cell className="text-left">
                                    <Button primary size='small'> <Icon style={{marginRight:'0'}} onClick={() => props.onUpdate(data)} name="edit"/></Button>
                                    </Table.Cell>

                                    <Table.Cell className="text-left">
                                    <Button secondary size='small' ><Icon style={{marginRight:'0'}} onClick={() => props.onDelete(data.id)} name="trash"/></Button>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table>
            </Segment>
            {props.isCreateModelVisible && <Create onClose={props.onCreatePopupClose} />}
            {props.isUpdateModelVisible && <Update selectedUser={props.selectedUser} onClose={props.onUpdatePopupClose} />}
        </Segment.Group>
        /*  <div className="main">
           <div>
                <h2 className="main-header"><span className="header-span">React CRUD Operations </span><Button primary onClick={() => props.onCreate()}>+Add</Button></h2>
            </div> 
             <div style={{ marginTop: 20 }}>
                <Table unstackable singleLine>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>First Name</Table.HeaderCell>
                            <Table.HeaderCell>Last Name</Table.HeaderCell>
                            <Table.HeaderCell>Checkbox Value</Table.HeaderCell>
                            <Table.HeaderCell>Update</Table.HeaderCell>
                            <Table.HeaderCell>Delete</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {props.users && props.users.map((data) => {
                            return (
                                <Table.Row key={data.id}>
                                    <Table.Cell>{data.firstName}</Table.Cell>
                                    <Table.Cell>{data.lastName}</Table.Cell>
                                    <Table.Cell>{data.checkbox ? 'Checked' : 'Unchecked'}</Table.Cell>

                                    <Table.Cell>
                                        <Button primary onClick={() => props.onUpdate(data)}>Update</Button>
                                    </Table.Cell>

                                    <Table.Cell>
                                        <Button onClick={() => props.onDelete(data.id)}>Delete</Button>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table>
            </div> 
            {props.isCreateModelVisible && <Create onClose={props.onCreatePopupClose} />}
            {props.isUpdateModelVisible && <Update selectedUser={props.selectedUser} onClose={props.onUpdatePopupClose} />}
        </div>*/

    );
};

ReadComponent.displayName = "ReadComponent";

export default ReadComponent;